const STORAGE_PREFIX = 'shipping_company_modules_';
const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

/** Coerce module flag: only explicit 1 / true is on; 0 / false / "0" off. Missing → defaultOn. */
function flagTo01(value, defaultOn = true) {
  if (value === undefined || value === null || value === '') return defaultOn ? 1 : 0;
  const n = Number(value);
  if (Number.isNaN(n)) return defaultOn ? 1 : 0;
  return n !== 0 ? 1 : 0;
}

export function normalizeModules(raw) {
  if (!raw) {
    return { riders_enabled: 0, branches_enabled: 0, dispatch_enabled: 0 };
  }
  return {
    riders_enabled: flagTo01(raw.riders_enabled, true),
    branches_enabled: flagTo01(raw.branches_enabled, true),
    // Superadmin can disable dispatch; must respect 0 / "0"
    dispatch_enabled: flagTo01(raw.dispatch_enabled, true),
  };
}

export function modulesFromUser(user) {
  if (!user || user.riders_enabled === undefined) return null;
  return normalizeModules(user);
}

export function cacheCompanyModules(key, modules) {
  if (!key || !modules) return;
  try {
    sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify({
      ...normalizeModules(modules),
      ts: Date.now(),
    }));
  } catch {
    /* ignore quota errors */
  }
}

export function readCachedCompanyModules(key) {
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_PREFIX + key);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.ts && Date.now() - data.ts > CACHE_TTL_MS) return null;
    return normalizeModules(data);
  } catch {
    return null;
  }
}

export function isModuleEnabled(modules, moduleKey) {
  if (!modules) return false;
  if (moduleKey === 'riders') return modules.riders_enabled === 1;
  if (moduleKey === 'branches') return modules.branches_enabled === 1;
  if (moduleKey === 'dispatch') return modules.dispatch_enabled === 1 && modules.riders_enabled === 1;
  return true;
}

export function resolveModuleCacheKey({ slug, companyId } = {}) {
  if (slug) return slug;
  if (companyId) return `id_${companyId}`;
  return null;
}